import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';

@Component({
  selector: 'app-header-nav',
  imports: [RouterModule],
  templateUrl: './header-nav.html',
  changeDetection: ChangeDetectionStrategy.Default
})
export class HeaderNavComponent implements OnInit {
  @Input() isCollapsed = false;
  @Output() toggleCollapse = new EventEmitter<void>();

  private readonly auth = inject(AuthService);

  isAdmin = false;
  canViewTelemetry = false;

  ngOnInit() {
    const user = this.auth.getCurrentUser();
    const role = user?.systemRole ?? 0;
    this.isAdmin = role === 1 || role === 2; // 1=SuperAdmin, 2=Admin
    this.canViewTelemetry = role === 1 || role === 2 || role === 3; // SuperAdmin, Admin, BIMManager
  }

  onToggleCollapse(): void {
    this.toggleCollapse.emit();
  }
}
